import React, { useState } from "react"
import { useForm } from "react-hook-form"

import * as styles from "./search-module.module.scss"

type SearchModuleProps = {
  searchPlaceholder: string
  searchRequestSlug: string
  buttonSearchAriaLabel?: string
  isMobileSearchBar?: boolean
  darkMode?: boolean
  onMouseOver?: () => void
  onMouseLeave?: () => void
  onSelect?: () => void
  onBlur?: () => void
}

const SearchModule: React.FC<SearchModuleProps> = ({
  searchPlaceholder,
  searchRequestSlug,
  buttonSearchAriaLabel,
  isMobileSearchBar,
  darkMode,
  onMouseOver,
  onMouseLeave,
  onSelect,
  onBlur,
}) => {
  const { register } = useForm()
  const [searchWordExist, setSearchWordExist] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")

  const checkIfInputIsEmpty = e => {
    if (e.target.value.length > 0) {
      setSearchWordExist(true)
    } else {
      setSearchWordExist(false)
    }
  }

  const handleChange = e => {
    setSearchTerm(e.target.value)
    checkIfInputIsEmpty(e)
  }

  const handleSubmit = e => {
    if (searchTerm === "") {
      e.preventDefault()
    }
  }

  const handleMouseLeave = () => {
    if (!searchWordExist && onMouseLeave) onMouseLeave()
  }
  const handleBlur = () => {
    if (!searchWordExist && onBlur) onBlur()
  }

  return (
    <form
      method="get"
      className={styles.searchForm}
      action={`/${searchRequestSlug}`}
      onMouseOver={onMouseOver}
      onMouseLeave={handleMouseLeave}
      onSelect={onSelect}
      onBlur={handleBlur}
      onSubmit={handleSubmit}
      role="search"
    >
      <input
        type="text"
        name="query"
        className={
          isMobileSearchBar
            ? styles.searchBarMobile
            : darkMode
              ? styles.searchBarCollapsedDark
              : styles.searchBarCollapsed
        }
        style={{ width: (searchWordExist || isMobileSearchBar) && 310 }}
        placeholder={isMobileSearchBar ? searchPlaceholder : ""}
        {...register("query")}
        onChange={handleChange}
        aria-label="searchInput"
      />
      <button
        type="submit"
        className={
          isMobileSearchBar
            ? styles.submitInputButtonMobile
            : styles.submitInputButtonCollapsed

        }
        aria-label={buttonSearchAriaLabel || "Submit search"}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
          <path d="M13 12.5L18 17.5M15 8.5C15 12.366 11.866 15.5 8 15.5C4.13401 15.5 1 12.366 1 8.5C1 4.63401 4.13401 1.5 8 1.5C11.866 1.5 15 4.63401 15 8.5Z" stroke="#032650" stroke-width="2" />
        </svg>
      </button>
    </form>
  )
}

export default SearchModule
